import FilesEntity from '../files/files'

export default interface CustomersEntity {
	_id?: string
	role: CustomerRoles
	images?: FilesEntity[]
	name: string
	lastname: string
	email: string
	phone: number
	password: string
	address?: CustomersAddressEntity[]
	_created?: Date
	_modified?: Date
	_deleted?: boolean
}

export enum CustomerRoles {
	customer = 'customer',
}

export interface CustomersAddressEntity {
	_id?: string
	fullname: string
	document_type: string
	document: number
	province: string
	city: string
	neighborhood: string
	street_type: string
	street: string
	number_home: string
	type_home: string
	phone: number
	additional_references?: string
	postal_code: string
	_created?: Date
	_modified?: Date
	_deleted?: boolean
}

export interface CreateCustomerEntity {
	_id?: string
	role?: CustomerRoles
	name: string
	lastname: string
	email: string
	phone: number
	code?: number
	password: string
	address?: CustomersAddressEntity[]
	_created?: Date
}

export interface LoginModel {
	email: string
	passwordCurrent: string
	passwordNew?: string
}
